import { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Heart, Shield, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export default function MyBenefitsPage() {
  const [benefits, setBenefits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/api/employee-portal/benefits`);
        setBenefits(r.data.benefits || r.data || []);
      } catch(e){ if(e?.response?.status !== 403) toast.error('Failed to load benefits'); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen p-6 bg-gray-50" data-testid="employee-benefits-page">
      <div className="max-w-5xl mx-auto space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">My Benefits</h1>
          <p className="text-gray-600 mt-1">Enrolled programs and eligibility.</p>
        </div>
        {loading ? <div className="text-gray-500">Loading…</div> :
         benefits.length === 0 ? <Card><CardContent className="p-8 text-center text-gray-500 italic">
           No benefits enrolled yet. Contact HR to enroll.
         </CardContent></Card> :
         <div className="grid md:grid-cols-2 gap-4">
           {benefits.map((b, i) => (
             <Card key={i} data-testid={`benefit-card-${i}`}>
               <CardHeader className="flex flex-row items-center justify-between pb-3">
                 <div className="flex items-center gap-3">
                   <div className="bg-pink-100 p-2 rounded-lg"><Heart className="h-5 w-5 text-pink-600" /></div>
                   <CardTitle className="text-lg">{b.name || b.plan_name || b.title}</CardTitle>
                 </div>
                 {b.enrolled && <Badge className="bg-emerald-100 text-emerald-800"><CheckCircle2 className="h-3 w-3 mr-1" />Enrolled</Badge>}
               </CardHeader>
               <CardContent className="space-y-2 text-sm">
                 {b.category && <div className="text-gray-600">Category: <span className="font-medium text-gray-900">{b.category}</span></div>}
                 {b.provider && <div className="text-gray-600 flex items-center gap-1"><Shield className="h-3 w-3" /> {b.provider}</div>}
                 {b.coverage && <div className="text-gray-600">Coverage: {b.coverage}</div>}
                 {b.employee_contribution != null && <div className="text-gray-600">Your contribution: <span className="font-medium">${b.employee_contribution}/mo</span></div>}
                 {b.effective_date && <div className="text-xs text-gray-500 pt-1">Effective {b.effective_date}</div>}
               </CardContent>
             </Card>
           ))}
         </div>}
      </div>
    </div>
  );
}
